import React, { useState } from "react";
// import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
// import { updateShipmentDetails } from "../../storeRedux/actions";
import apiService from "../api/api.service";
import { getLocalStorage, setLocalStorage } from "../utils/helper";
import { updateOrder } from "../store/order";
import { setToast } from "../store/toast";

const ButtonResyncDetail = ({
  order_id,
  trackingCompany,
  trackingNumber,
  orderIndex,
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleClickResync = async () => {
    let message = null;
    try {
      setLoading(true); // set loading to true before making any API request
      const res = await apiService.postCoreServices("tracking", {
        carrier_name: trackingCompany,
        tracking_number: trackingNumber,
        type: "realtime",
      });
      if (res?.data?.message) {
        message = res.data.message;
      }
      if (res?.status === 200) {
        const { tracking_summary, tracking_detail } =
          res?.data?.tracking_status;
        await apiService.get("shipment/syncOrderById", { order_id });
        setLocalStorage("ot-page-rs-B21C14AD141E241161C6F1426F59B", true, 5);
        dispatch(
          updateOrder({ tracking_summary, tracking_detail, orderIndex })
        );
        // dispatch(updateShipmentDetails({ tracking_summary, tracking_detail }));
        dispatch(
          setToast({
            message: "Order updated successfully!",
            status: "success",
            description: "Button will enable after 5 minutes",
          })
        );
      } else {
        setLocalStorage("ot-page-rs-B21C14AD141E241161C6F1426F59B", true, 1);
        dispatch(
          setToast({
            message: "Oops! Re-sync failed",
            status: "error",
            description: "Retry after 1 minute",
          })
        );
      }
    } catch (error) {
      console.log(error);
      setLocalStorage("ot-page-rs-B21C14AD141E241161C6F1426F59B", true, 1);
      dispatch(
        setToast({
          message: message || "Something went wrong!",
          status: "error",
        })
      );
      setLoading(false);
    } finally {
      setLoading(false); // set loading to false after API request completes or throws error
    }
  };

  const isDisable =
    loading || getLocalStorage("ot-page-rs-B21C14AD141E241161C6F1426F59B");

  return (
    <div className="pb-2" style={{ paddingLeft: "12.5px" }}>
      <button
        onClick={() => handleClickResync()}
        disabled={isDisable}
        className="btn btn-track"
      >
        {/* {loading ? <Loading type={6} /> : "Re-sync"} */}
        Re-sync
      </button>
    </div>
  );
};

export default ButtonResyncDetail;
